import { ProductGiftConfig } from '../model/cart-slice'

const KEY = 'cart/gift-configs'

interface GiftConfigLsService {
	set(productId: number, config: ProductGiftConfig): void
	get(productId: number): ProductGiftConfig | null
	getAll(): Record<number, ProductGiftConfig>
	remove(productId: number): void
	clear(): void
}

export const giftConfigLsService: GiftConfigLsService = {
	set(productId: number, config: ProductGiftConfig) {
		try {
			const raw = localStorage.getItem(KEY)
			const map = raw ? (JSON.parse(raw) as Record<number, ProductGiftConfig>) : {}
			map[productId] = config
			localStorage.setItem(KEY, JSON.stringify(map))
			console.log(`[giftConfigLsService] Saved config for product ${productId}`, config.type)
		} catch (e) {
			console.error('[giftConfigLsService] Failed to save:', e)
		}
	},

	get(productId: number): ProductGiftConfig | null {
		try {
			const raw = localStorage.getItem(KEY)
			if (!raw) return null
			const map = JSON.parse(raw) as Record<number, ProductGiftConfig>
			return map[productId] || null
		} catch (e) {
			console.error('[giftConfigLsService] Failed to get:', e)
			return null
		}
	},

	getAll(): Record<number, ProductGiftConfig> {
		try {
			const raw = localStorage.getItem(KEY)
			return raw ? (JSON.parse(raw) as Record<number, ProductGiftConfig>) : {}
		} catch (e) {
			console.error('[giftConfigLsService] Failed to getAll:', e)
			return {}
		}
	},

	remove(productId: number) {
		try {
			const raw = localStorage.getItem(KEY)
			if (!raw) return
			const map = JSON.parse(raw) as Record<number, ProductGiftConfig>
			delete map[productId]
			localStorage.setItem(KEY, JSON.stringify(map))
			console.log(`[giftConfigLsService] Removed config for product ${productId}`)
		} catch (e) {
			console.error('[giftConfigLsService] Failed to remove:', e)
		}
	},

	clear() {
		try {
			localStorage.removeItem(KEY)
			console.log(`[giftConfigLsService] Cleared all configs`)
		} catch (e) {
			console.error('[giftConfigLsService] Failed to clear:', e)
		}
	}
}
